import React, { useEffect } from "react";
import { Form, Input, Row, Col } from "antd";

const KioskForm = ({ form, initialValues }) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);


  return (
    <Form
      form={form}
      layout="vertical"
      name="editKiosk"
      initialValues={initialValues}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="kiosk_id"
            label="Kiosk ID"
            rules={[{ required: true, message: "Please input the kiosk ID!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please input the name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="company_id"
            label="Company ID"
            rules={[
              { required: true, message: "Please input the company ID!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="open_time"
            label="Open Time"
            rules={[{ required: true, message: "Please input the open time!" }]}
          >
            <Input type="time" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="close_time"
            label="Close Time"
            rules={[
              { required: true, message: "Please input the close time!" },
            ]}
          >
            <Input type="time" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="address_1"
            label="Address 1"
            rules={[{ required: true, message: "Please input the address 1!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="address_2" label="Address 2">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="unit_number"
            label="Unit Number"
            rules={[
              { required: true, message: "Please input the unit number!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="postal_code"
            label="Postal Code"
            rules={[
              { required: true, message: "Please input the postal code!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="country"
            label="Country"
            rules={[{ required: true, message: "Please input the country!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default KioskForm;
